import React from "react";
import { AiOutlineCalendar } from "react-icons/ai";

const AllEvents = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] bg-white rounded-lg shadow-sm p-8">
      <AiOutlineCalendar size={64} className="text-gray-300 mb-4" />
      <h2 className="text-xl font-semibold text-gray-700 mb-2">
        Events Management
      </h2>
      <p className="text-gray-500 text-center max-w-md">
        The events management feature is currently not available. This section
        will display all events created by sellers on the platform.
      </p>
    </div>
  );
};

export default AllEvents;
